import { render, staticRenderFns } from "./UnosStetnogDogadjaja.vue?vue&type=template&id=a168182a&scoped=true&"
import script from "./UnosStetnogDogadjaja.vue?vue&type=script&lang=ts&"
export * from "./UnosStetnogDogadjaja.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a168182a",
  null
  
)

export default component.exports